import './ManualPlateTypeEditor.scss';
import PropTypes from 'prop-types';
import GuidanceManualPlateContainer from './GuidanceManualPlateContainer';
import MotionControlManualPlateContainer from './MotionControlManualPlateContainer';

function ManualPlateTypeEditor({selectedWellStyle}) {
  return (
    <>
      <div
        className="left-panel"
        style={{
          width: '63vw',
          borderRight: 'none',
          height: 'calc(100vh - 64px)',
          overflow: 'auto',
        }}
      >
        <GuidanceManualPlateContainer selectedWellStyle={selectedWellStyle || {}} />
      </div>
      <div
        className="right-panel"
        style={{
          width: '37vw',
          flex: 2,
          height: 'calc(100vh - 63px)',
        }}
      >
        <MotionControlManualPlateContainer />
      </div>
    </>
  );
}

ManualPlateTypeEditor.propTypes = {
  selectedWellStyle: PropTypes.object.isRequired,
};

export default ManualPlateTypeEditor;
